import React, { Fragment, useContext } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ProductContext from "../../context/products/ProductContext";
import Spinner from "../layout/Spinner";

const Products = () => {
  const productContext = useContext(ProductContext);
  const {
    products,
    filtered,
    loading,
    setCurrent,
    // clearCurrent
  } = productContext;

  if (products === null || (products.length === 0 && !loading)) {
    return <h4> Please add a product </h4>;
  }

  return (
    <Fragment>
      {" "}
      {products !== null && !loading ? (
        <TransitionGroup>
          {" "}
          {filtered !== null ? (
            <CSSTransition>
              <div
                className="overflow-auto "
                style={{
                  maxHeight: "68vh",
                }}
              >
                <table
                  className="table table-hover"
                  style={{
                    border: "1px solid rgb(227, 227, 227)",
                    borderRadius: "0.5rem",
                  }}
                >
                  <tbody>
                    {" "}
                    {filtered.map((item, index) => (
                      <tr
                        style={{
                          fontSize: "0.9rem",
                        }}
                      >
                        <td
                          style={{
                            padding: "3.5% 10%",
                          }}
                          id="product_id"
                          onClick={() => {
                            setCurrent(item);
                          }}
                          key={item.product_id}
                        >
                          {item.product_id}{" "}
                        </td>{" "}
                      </tr>
                    ))}{" "}
                  </tbody>{" "}
                </table>{" "}
              </div>{" "}
            </CSSTransition>
          ) : (
            <CSSTransition>
              <div
                className="overflow-auto "
                style={{
                  maxHeight: "68vh",
                }}
              >
                <table
                  className="table table-hover"
                  style={{
                    border: "1px solid rgb(227, 227, 227)",
                    borderRadius: "0.5rem",
                  }}
                >
                  <tbody>
                    {" "}
                    {products.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          fontSize: "0.9rem",
                        }}
                      >
                        <td
                          style={{
                            padding: "3.5% 10%",
                          }}
                          id="product_id"
                          onClick={() => {
                            setCurrent(item);
                          }}
                          key={item.product_id}
                        >
                          {item.product_id}{" "}
                        </td>{" "}
                      </tr>
                    ))}{" "}
                  </tbody>{" "}
                </table>{" "}
              </div>{" "}
            </CSSTransition>
          )}{" "}
        </TransitionGroup>
      ) : (
        <Spinner />
      )}{" "}
    </Fragment>
  );
};

export default Products;
